import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d2f873e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "invite-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "教学视频", -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  key: 0,
  class: "aliPlayer"
};
import { env } from "md-base-tools/env";
import { onMounted, reactive } from "vue";
import { GoBack } from "../../utils/tools";
import { useRoute } from "vue-router";
import CompVideo from "../../components/project/video.vue";
export default {
  setup(__props) {
    const route = useRoute();
    const state = reactive({
      if_video_play: false,
      if_video_end: false,
      video_cover: "",
      video_url: ""
    });
    onMounted(() => {
      document.title = "教学视频";
      console.log('query-----', route.query);
      if (route.query.video_url && route.query.video_url.length > 0) {
        state.video_url = route.query.video_url;
        state.video_cover = route.query.video_url.replace(".mp4", ".png");
      }
    });
    function playVideo() {
      state.if_video_play = true;
    }

    //离开页面
    function handleGoBack() {
      GoBack();
    }

    //播放完成
    function videoEndEvent() {
      state.if_video_play = false;
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", {
        class: _normalizeClass([{
          headerIOS: _unref(env).isModianIos()
        }, {
          headerAndroid: _unref(env).isModianAndroid()
        }, {
          isFix: _ctx.isFix
        }])
      }, [_createVNode(_component_van_image, {
        class: "back-btn",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_white.png', 32),
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
      }, null, 8, ["src"]), _hoisted_2], 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "video",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => playVideo(_unref(state).video_url), ["stop"]))
      }, [_unref(state).if_video_play ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(CompVideo, {
        class: "videoController",
        video_url: _unref(state).video_url,
        onVideoEndEvent: videoEndEvent
      }, null, 8, ["video_url"])])) : _createCommentVNode("", true), _createVNode(_component_van_image, {
        "lazy-load": "",
        class: "video-cover",
        src: _ctx.$imgUrlFilter(_unref(state).video_cover, 750)
      }, null, 8, ["src"]), _createElementVNode("div", {
        class: "play-btn",
        style: _normalizeStyle(`background-image:url(${_ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/video_play@2x.png', 112, 112)});`)
      }, null, 4)])])]);
    };
  }
};